// extracted by mini-css-extract-plugin
export default {"root":"Author_root__xMsu9"};